export function translate(lang, en, fr) {
  return lang === "en" ? en : fr;
}
